import httpServe from './httpServe'
let team = {}


team.queryClassStudent = async function(param = {}) {
    let url = httpServe.getTeamUrl('/api/classStudent/queryClassStudent')
    let res = await httpServe.ajaxPost(url, param)
    return res.data
}
team.queryNowTerm = async function(param) {
        let url = httpServe.getTeamUrl('/api/term/queryNowTerm')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //获取学员评估详情
team.queryEstimateDetailByStudent = async function(param) {
        let url = httpServe.getTeamUrl('/api/teachingEvaluationScore/queryEstimateDetailByStudent');
        let res = await httpServe.ajaxPost(url, param)
        return res['data'];
    }
    // 查询课程
team.queryCourse = async function(param = {}) {
    let url = httpServe.getTeamUrl('/api/course/queryCourse')
    let res = await httpServe.ajaxPost(url, param)
    return res.data
}
team.queryConfig = async function(param) {
    let url = httpServe.getTeamUrl('/api/student/queryConfig')
    let res = await httpServe.ajaxPost(url, param)
    return res.data
}
team.queryStudentById = async function(param) {
        let url = httpServe.getTeamUrl('/api/student/queryStudentById')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //考情详情
team.countBySingleStudent = async function(param) {
        let url = httpServe.getTeamUrl('/api/kaoqin/countBySingleStudent ')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //检测是否可选择自定义年龄减免
team.checkHalf = async function(param) {
    let url = httpServe.getTeamUrl('/api/student/checkHalf');
    let res = await httpServe.ajaxPost(url, param)
    return res['data'];
};

//退班
team.quitClass = async function(param) {
        let url = httpServe.getTeamUrl('/api/student/quitClass')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    // 查询评估项列表(分页)
team.queryTeachingEvaluationItem = async function(param = {}) {
        let url = httpServe.getTeamUrl('/api/teachingEvaluationItem/queryTeachingEvaluationItem')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //创建或者修改请假记录
team.leaveCreateOrUpdate = async function(param = {}) {
    let url = httpServe.getTeamUrl('/api/leave/createOrUpdate')
    let res = await httpServe.ajaxPost(url, param)
    return res.data
}

//创建或者修改请假记录
team.leaveQueryLeaveClass = async function(param = {}) {
        let url = httpServe.getTeamUrl('/api/classStudent/queryLeaveClass')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    //查询订单状态
team.queryOrderDetail = async function(param) {
        let url = httpServe.getTeamUrl('/api/student/queryOrderDetail');
        let res = await httpServe.ajaxPost(url, param)
        return res['data'];
    }
    //创建或者修改请假记录
team.leaveCountHours = async function(param = {}) {
        let url = httpServe.getTeamUrl('/api/lessonsplandetail/countHours')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    // 博思票据
team.loadBoshInvoice = async function(param) {
        let url = httpServe.getTeamUrl('/api/student/loadBoshInvoice')
        let res = await httpServe.ajaxPost(url, param)
        return res.data
    }
    // 获取支付方式按钮
team.loadPayButton = async function(param) {
    let url = httpServe.getTeamUrl('/api/company/loadPayButton')
    let res = await httpServe.ajaxPost(url, param)
    return res.data
}
export default team


// WEBPACK FOOTER //
// ./src/utils/team.js